import { useGLTF } from '@react-three/drei'
import { useSnapshot } from 'valtio'
import { state } from '../../context/store'
import {
  modelParts,
  leftLogoParts,
  rightLogoParts,
  leftLogoCoords,
  rightLogoCoords,
  numberCoords,
} from '../../assets/models/363'
import {
  Ribs,
  MainSeat,
  RaceNumber,
  LogoMain,
  LogoRight,
  LogoLeft,
  TopPanelTexture,
} from './ModelSubComponents'

// This is the main Scooter seat Model (AKA Honda Navi)
// Link to test
// /?type=scooter&subtype=ribbed&test=yes

const Model363 = (props) => {
  const snap = useSnapshot(state.current)
  const { nodes, materials } = useGLTF(modelParts.main)

  // Model Variables
  const masterScale = 1
  const neededRibs = 7
  const ribPosition = [0.002, 0.025, 0.285]
  const ribScale = 1.063
  const topPanelTextureRepeat = 3
  const enjoyLogoPosition = [0.001, -0.072, 0.292]
  const enjoyLogoScale = 1
  const hexaLogoPosition = [0.001, -0.074, 0.291]
  const hexaLogoScale = 0.768

  //________ No edits required below ________//

  // Controls which extra parts are visible
  const visibleRibs = snap.choices.ribs.selected.mode !== 'no'
  const visibleTopLogo = snap.initialChoices.logoSize !== 'none'
  const visibleNumber = snap.choices.raceNumber.selected.mode === 'number'
  const visiblePattern = snap.choices.topPanel.selected.src !== null

  return (
    <group {...props} dispose={null} scale={masterScale}>
      <MainSeat nodes={nodes} materials={materials}>
        {visiblePattern && (
          <TopPanelTexture
            repeat={topPanelTextureRepeat}
            normal={materials.TopPanel.normalMap}
          />
        )}
      </MainSeat>

      {visibleRibs && (
        <Ribs
          model={modelParts.ribs}
          neededRibs={neededRibs}
          position={ribPosition}
          scale={ribScale}
          tiles={1.3}
        />
      )}
      {visibleTopLogo && (
        <LogoMain
          model={modelParts.logoMain}
          model2={modelParts.logoHexa}
          position={enjoyLogoPosition}
          scale={enjoyLogoScale}
          position2={hexaLogoPosition}
          scale2={hexaLogoScale}
        />
      )}

      <RaceNumber
        model={modelParts.number}
        coords={numberCoords}
      />
      <LogoLeft
        model={leftLogoParts}
        logo={snap.choices.sideLogos.selected.mode}
        coords={leftLogoCoords}
      />
      <LogoRight
        model={rightLogoParts}
        logo={snap.choices.sideLogos.selected.mode}
        coords={rightLogoCoords}
      />
    </group>
  )
}

export default Model363

useGLTF.preload(modelParts.main)
useGLTF.preload(modelParts.logoLeft)
useGLTF.preload(modelParts.logoRight)
useGLTF.preload(modelParts.logoMain)
